import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import ContentFooter from '@/layout/ContentFooter.vue';
import UserService from '@/services/user/user.service';

@Component({
    components: {
        'content-footer': ContentFooter
    }
})
export default class App extends Vue {

    @Inject('userService') private userService: () => UserService;

    @Prop({default: 'true'})
    public sidebar: boolean;

    public hasAnyAuthority(authorities: any): boolean {
        return this.userService().hasAnyAuthority(authorities);
    }

    public goTo(url, isBlank) {
        window.open(url, isBlank ? "_blank" : "");
    }

    public get authenticated(): boolean {
        return this.$store.getters.authenticated;
    }

}

